import { Injectable } from '@angular/core';
import { HttpClient,HttpHeaders } from '@angular/common/http';

import { RegistrationHealthElement } from "../models/RegistrationHealthModel";

///import { environment } from '../../../environments/environment';
import { environment } from '../../environments/environment';
//   private apiUrl = environment.apiUrl;

@Injectable()
export class RegistrationHealthService {

   ///import { environment } from '../../../environments/environment';
   private apiUrl = environment.apiUrl;

constructor(private http: HttpClient) { }


  /////////////////////////////  ------------- CURD -----------------  /////////////////////

  addRegistrationHealthData(objj:RegistrationHealthElement) {
    var httpOptions = {
      headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Credentials': 'true',
          'Access-Control-Allow-Headers': 'Content-Type',
          'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE',
          'key': 'x-api-key',
          'value': 'NNctr6Tjrw9794gFXf3fi6zWBZ78j6Gv3UCb3y0x',

      })
  };
  return this.http.post(""+this.apiUrl+"/RegistrationHealth/AddRegistrationHealth",
  JSON.stringify(objj),
   httpOptions
  )
  }

  addRegistrationHealthDrugTestData(objj:RegistrationHealthElement) {
    var httpOptions = {
      headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Credentials': 'true',
          'Access-Control-Allow-Headers': 'Content-Type',
          'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE',
          'key': 'x-api-key',
          'value': 'NNctr6Tjrw9794gFXf3fi6zWBZ78j6Gv3UCb3y0x',

      })
  };
  //return this.http.post('"+this.apiUrl+"/RegistrationHealth/AddRegistrationHealthDrugTest',
  return this.http.post(""+this.apiUrl+"/RegistrationHealth/AddRegistrationHealthDrugTest",
  JSON.stringify(objj),
   httpOptions
  )
  }

  /////////////////////////////  ------------- CURD -----------------  /////////////////////




  /////////////////////////  ------------  GET ALL ------------   //////////////////////////

  getAllRegistrationHealthData( mid:number) {
    var httpOptions = {
      headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Credentials': 'true',
          'Access-Control-Allow-Headers': 'Content-Type',
          'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE',
          'key': 'x-api-key',
          'value': 'NNctr6Tjrw9794gFXf3fi6zWBZ78j6Gv3UCb3y0x',

      })
  };
    return this.http.get(""+this.apiUrl+"/RegistrationHealth/GetAllRegistrationHealthByMID?MID="+mid,httpOptions);
  }
  
  getAllRegistrationHealthDrugTestData( mid:number) {
    var httpOptions = {
      headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Credentials': 'true',
          'Access-Control-Allow-Headers': 'Content-Type',
          'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE',
          'key': 'x-api-key',
          'value': 'NNctr6Tjrw9794gFXf3fi6zWBZ78j6Gv3UCb3y0x',

      })
  };
    return this.http.get(""+this.apiUrl+"/RegistrationHealth/GetAllRegistrationHealthDrugTestByMID?MID="+mid,httpOptions);
  }

   /////////////////////////  ------------  GET ALL ------------   //////////////////////////




}
